(function () {
  const cardCache = new Map();

  function isModelShotView() {
    return document.getElementById('collectionMain')?.classList.contains('modelShot') || false;
  }

  function cardSectionUrl(button) {
    try {
      const url = new URL(button.dataset.url, window.location.origin);
      url.searchParams.set('section_id', 'card-product');
      return url.pathname + url.search;
    } catch (error) {
      return null;
    }
  }

  async function fetchCardHtml(url) {
    if (cardCache.has(url)) return cardCache.get(url);

    const response = await fetch(url, {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to load product card section');
    }

    const html = await response.text();
    const card = new DOMParser().parseFromString(html, 'text/html').querySelector('a[data-id]');

    if (!card) {
      throw new Error('Product card section response missing card element');
    }

    cardCache.set(url, card.outerHTML);
    return card.outerHTML;
  }

  function markSelected(button, card) {
    card.querySelectorAll('button[data-id]').forEach((b) => b.removeAttribute('data-selected'));
    button.setAttribute('data-selected', 'true');
  }

  function priceMarkup(swatchData, soldOutLabel) {
    if (swatchData.available !== 'true') {
      return '<span class="uppercase text-[10px] font-normal lg:text-xs">' + soldOutLabel + '</span>';
    }

    if (swatchData.compareAtPrice && swatchData.compareAtPrice !== swatchData.price) {
      return (
        '<span class="uppercase font-normal"><span class="line-through">' +
        swatchData.compareAtPrice +
        '</span> <span class="text-[#ae0200]">' +
        swatchData.price +
        '</span></span>'
      );
    }

    return '<span class="uppercase font-normal">' + swatchData.price + '</span>';
  }

  function applyOptimisticText(card, button) {
    const swatchData = button.dataset;

    const titleEl = card.querySelector('[data-card-title]');
    if (titleEl && swatchData.title) {
      titleEl.textContent = swatchData.title;
    }

    const colourEl = card.querySelector('[data-card-colour]');
    if (colourEl && swatchData.colour) {
      colourEl.textContent = swatchData.colour;
    }

    const priceEl = card.querySelector('[data-card-price]');
    if (priceEl) {
      priceEl.innerHTML = priceMarkup(swatchData, priceEl.dataset.soldOutLabel || 'Sold out');
    }

    if (swatchData.url) card.setAttribute('href', swatchData.url);
    if (swatchData.handle) card.dataset.handle = swatchData.handle;
    if (swatchData.id) card.dataset.id = swatchData.id;
  }

  async function applyOptimisticImages(card, button) {
    const container = card.querySelector('[data-card-image-container]');
    if (!container) return;

    const standardImage = button.dataset.image || '';
    const modelShotImage = button.dataset.imageModelshot || '';

    const visibleSource = isModelShotView() ? modelShotImage || standardImage : standardImage;
    if (visibleSource) {
      const preloader = new Image();
      preloader.src = visibleSource;
      await Promise.race([preloader.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 1500))]);
    }

    if (!button.isConnected || button.getAttribute('data-selected') !== 'true') return;

    const packSlots = 2;
    container.querySelectorAll('img').forEach((img, index) => {
      const source = index < packSlots ? standardImage : modelShotImage;
      if (!source) return;

      img.src = source;
      img.setAttribute('data-src', source);
      if (button.dataset.title) img.alt = button.dataset.title;
      img.srcset = '';
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
    });
  }

  function applyGridViewSizes(images) {
    const view = document.getElementById('collection-product-list')?.dataset.view;
    if (!view) return;

    images.forEach((img) => {
      const sizes = img.dataset['view' + view];
      if (sizes) img.setAttribute('sizes', sizes);
    });
  }

  const productAttributes = ['href', 'data-id', 'data-handle'];

  function adoptFreshCard(card, freshCard) {
    productAttributes.forEach((name) => {
      const value = freshCard.getAttribute(name);
      if (value !== null) card.setAttribute(name, value);
    });

    card.replaceChildren(...freshCard.childNodes);
  }

  async function swapWhenImageReady(card, freshCard, button) {
    const images = freshCard.querySelectorAll('[data-card-image-container] img');
    applyGridViewSizes(images);

    const visibleImage = isModelShotView() ? images[2] || images[0] : images[0];
    if (visibleImage) {
      visibleImage.setAttribute('loading', 'eager');
    }

    const listItem = card.closest('li');
    if (listItem) listItem.style.position = 'relative';

    freshCard.style.position = 'absolute';
    freshCard.style.inset = '0';
    freshCard.style.visibility = 'hidden';
    card.insertAdjacentElement('afterend', freshCard);

    try {
      if (visibleImage) {
        await Promise.race([visibleImage.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 3000))]);
      }

      if (!button.isConnected || button.getAttribute('data-selected') !== 'true') return;

      if (listItem && button.dataset.handle) {
        listItem.dataset.productHandle = button.dataset.handle;
      }

      adoptFreshCard(card, freshCard);
    } catch (error) {
      console.error(error);
    } finally {
      freshCard.remove();
      if (listItem) listItem.style.position = '';
    }
  }

  window.replaceProductCardFromSwatch = async function (button) {
    if (!button) return;

    const card = button.closest('a');
    if (!card) return;

    markSelected(button, card);
    applyOptimisticText(card, button);
    applyOptimisticImages(card, button).catch(console.error);

    const url = cardSectionUrl(button);
    if (!url) return;

    let cardHtml;
    try {
      cardHtml = await fetchCardHtml(url);
    } catch (error) {
      console.error(error);
      return;
    }

    if (!button.isConnected || button.getAttribute('data-selected') !== 'true') return;

    const template = document.createElement('template');
    template.innerHTML = cardHtml.trim();
    const freshCard = template.content.firstElementChild;
    if (!freshCard) return;

    await swapWhenImageReady(card, freshCard, button);
  };
})();
